export default {
  // primary: '#021c5e',
  primary: '#0e3aff',
  secondary: '#d9fd00',
  tertiary: '#495057',
  accent: '#82B1FF',
  error: '#f52b1b',
  info: '#00d3ee',
  success: '#3cc542',
  warning: '#ffa21a'
}
